/* Skinibi cart drawer upsells. Offer settings: Shopify admin > Content > Metaobjects > Cart offers. */
(() => {
  const dataEl = document.getElementById('skb-data');
  if (!dataEl) return;
  let D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  const C = D.cfg;

  const uniq = (arr) => { const seen = new Set(); return (arr || []).filter((x) => x && !seen.has(x.p) && seen.add(x.p)); };
  const FIG = uniq(D.fig), KC = uniq(D.kc), TEE = uniq(D.tee);
  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  const QUICK = ['XS', 'S', 'M', 'L'];
  TEE.forEach((t) => { t.sizes = (t.sizes || []).filter(Boolean).sort((a, b) => SIZE_ORDER.indexOf(a.s) - SIZE_ORDER.indexOf(b.s)); });
  const CAT_OF = { 'action figure': 'fig', keychain: 'kc', 't-shirt': 'tee' };
  const NAME = { fig: ['figure', 'figures'], kc: ['keychain', 'keychains'], tee: ['tee', 'tees'] };
  const LIST = { fig: FIG, kc: KC, tee: TEE };
  const ADDON = new Set([D.wrap && D.wrap.v, D.card && D.card.v].filter(Boolean));
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  const norm = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const rs = (paise) => '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  const ord = (n) => n + (['th', 'st', 'nd', 'rd'][(n % 100 > 10 && n % 100 < 14) ? 0 : (n % 10 < 4 ? n % 10 : 0)]);
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  let cart = null;
  let busy = false;
  const pickSize = {};
  let giftOpen = false;
  let cardDraft = '';
  let cleaning = false;
  try { giftOpen = sessionStorage.getItem('skb-gift') === '1'; } catch (e) {}

  /* ---------- cart model ---------- */
  function catOf(item) { return CAT_OF[(item.product_type || '').toLowerCase()] || null; }
  function agentOf(item, cat) {
    const hit = cat && LIST[cat].find((x) => x.p === item.product_id);
    if (hit) return hit.a;
    return (item.product_title || '').replace(/\(pre order\)/i, '').replace(/acrylic keychain|oversized tee/i, '').split(' - ')[0].trim();
  }
  function model() {
    const m = { fig: [], kc: [], tee: [], ids: new Set(), agents: new Set(), lines: {} };
    (cart.items || []).forEach((it) => {
      m.ids.add(it.product_id);
      m.lines[it.variant_id] = it;
      const cat = catOf(it);
      if (!cat) return;
      const a = agentOf(it, cat);
      m.agents.add(norm(a));
      let b2gOff = 0;
      (it.line_level_discount_allocations || []).forEach((d) => { if (/buy\s*2/i.test(d.discount_application.title)) b2gOff += d.amount; });
      let freeLeft = it.original_price ? Math.round(b2gOff / it.original_price) : 0;
      for (let q = 0; q < it.quantity; q++) {
        m[cat].push({ price: it.original_price, img: it.image, agent: a, free: freeLeft-- > 0 });
      }
    });
    return m;
  }
  function units(m) { return { fig: m.fig.map((u) => u.price), kc: m.kc.map((u) => u.price), tee: m.tee.map((u) => u.price) }; }

  /* Mirrors the Shopify discounts: Buy 2 Get 1 per category, or the pair price, whichever saves more. */
  function est(u) {
    let b2g = 0;
    if (C.b2g1) ['fig', 'kc', 'tee'].forEach((c) => {
      const a = [...u[c]].sort((x, y) => x - y);
      for (let i = 0; i < Math.floor(a.length / 3); i++) b2g += a[i];
    });
    let pair = 0;
    if (C.pair) {
      const k = [...u.kc].sort((x, y) => y - x);
      for (let i = 0; i < Math.min(u.fig.length, k.length); i++) pair += Math.max(0, k[i] - C.pairPrice * 100);
    }
    const sub = [...u.fig, ...u.kc, ...u.tee].reduce((s, x) => s + x, 0);
    return { sub, save: Math.max(b2g, pair), usePair: pair > b2g, total: sub - Math.max(b2g, pair) };
  }
  function marginal(u, cat, price) {
    const v = { fig: [...u.fig], kc: [...u.kc], tee: [...u.tee] };
    v[cat].push(price);
    return est(v).total - est(u).total;
  }

  const rail = (key, inner) => `<div class="skb-scroll"><button type="button" class="skb-arrow skb-arrow--prev" data-skb-scroll="-1" aria-label="Previous">&#8249;</button><div class="skb-rail" data-rail="${key}">${inner}</div><button type="button" class="skb-arrow skb-arrow--next" data-skb-scroll="1" aria-label="Next">&#8250;</button></div>`;

  /* ---------- blocks ---------- */
  function tracker(m, cat) {
    const list = m[cat], n = list.length;
    if (!n || !C.b2g1) return '';
    const u = units(m), nm = NAME[cat];
    const typical = (LIST[cat][0] && LIST[cat][0].price) || list[0].price;
    const freeNow = list.filter((x) => x.free).length;
    const total = n % 3 === 0 ? n + 3 : Math.ceil(n / 3) * 3;
    const show = Math.min(total, 9), start = total > 9 ? total - 9 : 0;
    let slots = '';
    for (let i = start; i < start + show; i++) {
      const filled = i < n, freeSlot = (i + 1) % 3 === 0;
      const img = filled && list[i].img ? `<img src="${esc(sized(list[i].img, 120))}" alt="" loading="lazy">` : '';
      slots += `<div class="skb-slot${filled ? ' is-on' : ''}${freeSlot ? ' is-free' : ''}">${filled ? img : (freeSlot ? 'FREE' : rs(typical))}</div>`;
    }
    let msg, sub = '', hot = false;
    const mg = marginal(u, cat, typical);
    if (n % 3 === 2) {
      hot = true;
      msg = mg <= 0 ? `Your ${ord(n + 1)} ${nm[0]} is free. Pick it below.` : `Add a ${ord(n + 1)} ${nm[0]} for ${rs(mg)} more.`;
      if (mg > 0) sub = 'Buy 2 Get 1 replaces the pair price here.';
    } else if (n % 3 === 1) {
      msg = `Add 1 more ${nm[0]}. Your ${ord(n + 2)} one is free.`;
    } else {
      const k = n / 3;
      msg = freeNow ? `${freeNow} ${nm[freeNow > 1 ? 1 : 0]} free, applied. Pay for 2 more and your ${ord(n + 3)} ${nm[0]} is free.` : 'Pair price beats Buy 2 Get 1 on this cart.';
      sub = `Buy ${2 * k + 2}, get ${k + 1} free: ${n + 3} ${nm[1]} for ${rs(typical * (2 * k + 2))}.`;
    }
    const label = { fig: 'Figures', kc: 'Keychains', tee: 'Tees' }[cat];
    return `<div class="skb-track${hot ? ' is-hot' : ''}">
      <div class="skb-track__lab"><span class="skb-eyebrow">Buy 2 Get 1 · ${label}</span><span class="skb-tag${freeNow ? ' is-free' : ''}">${freeNow ? freeNow + ' free' : n + ' in cart'}</span></div>
      <div class="skb-slots" style="grid-template-columns:repeat(${show},minmax(0,56px))">${slots}</div>
      <p class="skb-msg">${msg}${sub ? `<small>${sub}</small>` : ''}</p></div>`;
  }

  function pairCard(m) {
    if (!C.pair || !m.fig.length || m.kc.length >= m.fig.length) return '';
    const u = units(m);
    const haveKc = new Set(m.kc.map((x) => norm(x.agent)));
    let fig = null, kc = null;
    for (const f of m.fig) {
      const k = KC.find((x) => norm(x.a) === norm(f.agent) && !haveKc.has(norm(x.a)) && !m.ids.has(x.p));
      if (k) { fig = f; kc = k; break; }
    }
    if (!kc) { kc = KC.find((x) => !m.ids.has(x.p)); fig = m.fig[0]; }
    if (!kc) return '';
    const v = { fig: [...u.fig], kc: [...u.kc, kc.price], tee: [...u.tee] };
    if (!est(v).usePair) return '';
    const pp = C.pairPrice * 100;
    return `<div class="skb-pair">
      <div class="skb-thumb"><img src="${esc(kc.img)}" alt="" loading="lazy"></div>
      <div class="skb-pair__txt"><b>Pair the ${esc(kc.a)} keychain</b><small><s>${rs(kc.price)}</s> ${rs(pp)} with your figure. ${rs(fig.price + pp)} for the pair.</small></div>
      <button type="button" class="skb-btn" data-skb-add="${kc.v}">Add</button></div>`;
  }

  function picksCat(m) {
    const cats = ['fig', 'kc'].filter((c) => m[c].length);
    return cats.find((c) => m[c].length % 3 === 2) || cats.find((c) => m[c].length % 3 === 1) || (m.fig.length || !m.kc.length ? 'fig' : 'kc');
  }
  function picks(m) {
    const cat = picksCat(m);
    const opts = LIST[cat].filter((x) => !m.ids.has(x.p));
    if (!opts.length) return '';
    const u = units(m);
    const anyFree = opts.some((o) => marginal(u, cat, o.price) <= 0);
    const title = anyFree ? `Pick your free ${NAME[cat][0]}` : `Pick your next ${NAME[cat][0]}`;
    return `<div class="skb-picks"><h4 class="skb-h4">${title} <span class="skb-count-all">${opts.length} more</span></h4>${rail('picks-' + cat, opts.map((o) => {
      const free = marginal(u, cat, o.price) <= 0;
      return `<button type="button" class="skb-card" data-skb-add="${o.v}"><span class="skb-card__im"><img src="${esc(o.img)}" alt="" loading="lazy"></span><b>${esc(o.a)}</b><span>${free ? `<s>${rs(o.price)}</s> <em>FREE</em>` : rs(o.price)}</span></button>`;
    }).join(''))}</div>`;
  }

  function figCross(m, picksCat) {
    if (!m.kc.length || picksCat === 'fig') return '';
    const opts = FIG.filter((x) => !m.ids.has(x.p));
    if (!opts.length) return '';
    const figAgents = new Set(m.fig.map((x) => norm(x.agent)));
    const kcAgents = [...new Set(m.kc.map((x) => norm(x.agent)))].filter((a) => !figAgents.has(a));
    const matched = opts.filter((o) => kcAgents.includes(norm(o.a)));
    const list = [...matched, ...opts.filter((o) => !matched.includes(o))];
    const u = units(m);
    const v = { fig: [...u.fig, (list[0] || {}).price || 0], kc: [...u.kc], tee: [...u.tee] };
    const pairs = C.pair && m.kc.length > m.fig.length && est(v).usePair;
    const lead = matched[0];
    const kcPrice = m.kc[0].price, pp = C.pairPrice * 100;
    const head = pairs && lead ? `Make it a pair: ${esc(lead.a)} figure + keychain for ${rs(lead.price + pp)}.` : 'Pick a figure';
    const sub = pairs ? `Add a figure and your keychain drops from ${rs(kcPrice)} to ${rs(pp)}.` : '';
    return `<div class="skb-picks skb-cross"><h4 class="skb-h4">${head}</h4>${sub ? `<p class="skb-cross__sub">${sub}</p>` : ''}${rail('cross-fig', list.map((o) => {
      const isMatch = matched.includes(o);
      return `<button type="button" class="skb-card${isMatch ? ' is-match' : ''}" data-skb-add="${o.v}"><span class="skb-card__im"><img src="${esc(o.img)}" alt="" loading="lazy"></span><b>${esc(o.a)}</b><span>${rs(o.price)}${isMatch && pairs ? ' <em>PAIR</em>' : ''}</span></button>`;
    }).join(''))}</div>`;
  }

  function tees(m) {
    if (!C.tees || !TEE.length) return '';
    const inCart = new Set(m.tee.map((x) => norm(x.agent)));
    const match = TEE.filter((t) => m.agents.has(norm(t.a)) && !inCart.has(norm(t.a)) && t.sizes.some((s) => s.ok));
    const rest = TEE.filter((t) => !match.includes(t) && !inCart.has(norm(t.a)) && t.sizes.some((s) => s.ok));
    const show = [...match, ...rest];
    if (!show.length) return '';
    const n = m.tee.length;
    const sub = !C.b2g1 ? 'Oversized fit, 12 colours on the product page.' : n % 3 === 2 ? 'Your next tee is free with Buy 2 Get 1.' : n % 3 === 1 ? 'Add 1 more tee. Your 3rd one is free.' : 'Buy 2 Get 1 works on tees too.';
    const head = match.length ? `${esc(match[0].a)} has a tee now.` : 'Your agent, on a tee.';
    return `<div class="skb-launch">
      <div class="skb-launch__head"><span class="skb-tag is-new">New launch</span><span class="skb-eyebrow">Oversized tees</span></div>
      <h4 class="skb-launch__title">${head}</h4><p class="skb-launch__sub">${sub}</p>
      ${rail('tees', show.map((t) => {
        const avail = t.sizes.filter((s) => s.ok);
        const quick = avail.filter((s) => QUICK.includes(s.s));
        const row = quick.length ? quick : avail.slice(0, 4);
        const sel = row.find((s) => s.s === pickSize[t.p]) || row.find((s) => s.s === 'M') || row[0];
        const range = t.sizes.length ? `${t.sizes[0].s} to ${t.sizes[t.sizes.length - 1].s}` : '';
        return `<div class="skb-tee">
          <div class="skb-tee__im"><img src="${esc(t.img)}" alt="${esc(t.a)} oversized tee" loading="lazy"><span class="skb-sticker">${t.nc > 1 ? t.nc + ' colours' : 'More colours'}<br>${range}</span></div>
          <div class="skb-tee__meta"><b>${esc(t.a)} oversized tee</b><span>${rs(t.price)}</span></div>
          <div class="skb-sizes" role="group" aria-label="Size">${row.map((s) => `<button type="button" class="skb-sz" data-skb-size="${t.p}" data-size="${esc(s.s)}" aria-pressed="${s === sel}">${esc(s.s)}</button>`).join('')}</div>
          <a class="skb-more" href="${esc(t.u)}">More sizes and colours</a>
          <button type="button" class="skb-btn skb-btn--wide" data-skb-add="${sel.v}">Add · ${esc(sel.s)}</button></div>`;
      }).join(''))}</div>`;
  }

  function gift(m) {
    if (!C.gift || (!D.wrap && !D.card)) return '';
    const wrapLine = D.wrap && m.lines[D.wrap.v];
    const cardLine = D.card && m.lines[D.card.v];
    const on = giftOpen || !!wrapLine || !!cardLine;
    const msg = (cardLine && cardLine.properties && cardLine.properties['Card message']) || cardDraft;
    let body = '';
    if (on) {
      body += D.wrap ? `<div class="skb-gift__row"><span><b>Gift wrap</b><small>${rs(D.wrap.price)}</small></span>${wrapLine
        ? `<button type="button" class="skb-btn skb-btn--ghost" data-skb-remove="${esc(wrapLine.key)}">Remove</button>`
        : `<button type="button" class="skb-btn" data-skb-add="${D.wrap.v}">Add</button>`}</div>` : '';
      body += D.card ? `<div class="skb-gift__row skb-gift__row--card"><span><b>Handwritten card</b><small>${rs(D.card.price)} · we write your message by hand</small></span></div>
        <textarea id="skb-card-msg" class="skb-textarea" maxlength="200" rows="3" placeholder="Happy Diwali. Your main, on your desk.">${esc(msg)}</textarea>
        <div class="skb-gift__actions"><span class="skb-count">${msg.length}/200</span>${cardLine
          ? `<button type="button" class="skb-btn skb-btn--ghost" data-skb-remove="${esc(cardLine.key)}">Remove</button><button type="button" class="skb-btn" data-skb-card-save="${esc(cardLine.key)}">Save message</button>`
          : `<button type="button" class="skb-btn" data-skb-card-add="${D.card.v}">Add card</button>`}</div>
        <p class="skb-err" id="skb-card-err" hidden>Write the message for the card first.</p>` : '';
    }
    return `<div class="skb-gift"><label class="skb-gift__toggle"><input type="checkbox" id="skb-gift-on" ${on ? 'checked' : ''}><span><b>This is a gift</b><small>Gift wrap or a handwritten card, ${rs((D.wrap || D.card).price)} each.</small></span></label>${body}</div>`;
  }

  function summary() {
    const pp = C.prepaid > 0 ? `<span class="skb-foot__pp">Pay online: extra ${C.prepaid}% off <b>−${rs(cart.total_price * C.prepaid / 100)}</b></span>` : '';
    return `<div class="skb-foot"><span class="skb-foot__total">Total <b>${rs(cart.total_price)}</b></span>${pp}</div>`;
  }
  function bottom(inner) {
    const tax = inner.querySelector('.cart-drawer__footer .tax-note');
    let out = `<div class="skb-bottom"><div class="skb-bottom__row"><span>Estimated total</span><b>${rs(cart.total_price)}</b></div>`;
    if (C.prepaid > 0) out += `<div class="skb-bottom__row skb-bottom__pp"><span>Pay online, extra ${C.prepaid}% off<small>Applied at checkout</small></span><b>−${rs(cart.total_price * C.prepaid / 100)}</b></div>`;
    if (C.ship > 0) {
      const gap = C.ship * 100 - cart.total_price;
      out += gap > 0
        ? `<div class="skb-ship is-need">${rs(gap)} away from free prepaid shipping<div class="skb-bar"><i style="width:${Math.min(100, cart.total_price / (C.ship * 100) * 100)}%"></i></div></div>`
        : `<div class="skb-ship">✓ Free shipping on prepaid orders</div>`;
    }
    if (tax) out += `<p class="skb-tax">${tax.innerHTML}</p>`;
    return out + '</div>';
  }

  /* ---------- mount ---------- */
  function slot(inner, id, place) {
    let el = inner.querySelector('#' + id);
    if (!el) { el = document.createElement('div'); el.id = id; el.className = 'skb'; place(el); }
    return el;
  }
  function paint() {
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer && drawer.querySelector('.drawer__inner');
    if (!inner || !cart) return;
    const wrap = inner.querySelector('.drawer__cart-items-wrapper');
    const totals = inner.querySelector('.cart-drawer__footer .totals');
    const productCount = (cart.items || []).filter((i) => !ADDON.has(i.variant_id)).length;
    if (!productCount) {
      const orphans = (cart.items || []).filter((i) => ADDON.has(i.variant_id));
      if (orphans.length && !cleaning) {
        cleaning = true;
        const updates = {};
        orphans.forEach((i) => { updates[i.key] = 0; });
        post('/cart/update.js', { updates }).finally(() => { cleaning = false; });
      }
    }
    if (!wrap || !productCount) { inner.querySelectorAll('.skb').forEach((e) => e.remove()); drawer.classList.remove('skb-on'); return; }
    drawer.classList.add('skb-on');
    const m = model();
    const top = slot(inner, 'skb-top', (el) => wrap.before(el));
    const ext = slot(inner, 'skb-extras', (el) => wrap.after(el));
    const present = ['fig', 'tee', 'kc'].filter((c) => m[c].length);
    const hot = present.filter((c) => m[c].length % 3 === 2);
    const lead = hot.length ? hot.slice(0, 1) : present.sort((a, b) => m[b].length - m[a].length).slice(0, 1);
    top.innerHTML = lead.map((c) => tracker(m, c)).join('');
    const keep = {};
    ext.querySelectorAll('.skb-rail').forEach((r) => { keep[r.dataset.rail] = r.scrollLeft; });
    ext.innerHTML = pairCard(m) + picks(m) + figCross(m, picksCat(m)) + tees(m) + gift(m) + bottom(inner);
    ext.querySelectorAll('.skb-rail').forEach((r) => { if (keep[r.dataset.rail]) r.scrollLeft = keep[r.dataset.rail]; });
    if (totals) slot(inner, 'skb-sum', (el) => totals.before(el)).innerHTML = summary();
  }
  async function refresh() {
    try { cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch (e) { return; }
    paint();
  }

  async function post(url, body) {
    if (busy) return null;
    busy = true;
    document.querySelectorAll('.skb').forEach((e) => e.classList.add('is-busy'));
    try {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: location.pathname }) });
      const j = await r.json();
      if (!r.ok || j.status) { flash(j.description || j.message || 'That didn\'t work. Try again.'); return null; }
      if (Array.isArray(j.items) && 'total_price' in j) { cart = j; fresh = true; }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && j.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(j);
        if ('item_count' in j) {
          const empty = j.item_count === 0;
          drawer.classList.toggle('is-empty', empty);
          const items = drawer.querySelector('cart-drawer-items');
          if (items) items.classList.toggle('is-empty', empty);
        }
      } else location.reload();
      return j;
    } catch (e) { flash('That didn\'t work. Try again.'); return null; }
    finally { busy = false; document.querySelectorAll('.skb').forEach((e) => e.classList.remove('is-busy')); }
  }
  const add = (v, properties) => post('/cart/add.js', { items: [{ id: Number(v), quantity: 1, ...(properties ? { properties } : {}) }] });
  const change = (key, quantity, properties) => post('/cart/change.js', { id: key, quantity, ...(properties ? { properties } : {}) });
  function flash(text) {
    const ext = document.getElementById('skb-extras');
    if (!ext) return;
    let e = ext.querySelector('.skb-flash');
    if (!e) { e = document.createElement('p'); e.className = 'skb-flash skb-err'; ext.prepend(e); }
    e.textContent = text;
  }

  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-skb-scroll]');
    if (arrow && arrow.closest('.skb')) {
      e.preventDefault();
      const r = arrow.parentElement.querySelector('.skb-rail');
      r.scrollBy({ left: Number(arrow.dataset.skbScroll) * r.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    const t = e.target.closest('[data-skb-add],[data-skb-remove],[data-skb-size],[data-skb-card-add],[data-skb-card-save]');
    if (!t || !t.closest('.skb')) return;
    e.preventDefault();
    if (t.dataset.skbSize) { pickSize[t.dataset.skbSize] = t.dataset.size; paint(); return; }
    if (t.dataset.skbAdd) { add(t.dataset.skbAdd); return; }
    if (t.dataset.skbRemove) { change(t.dataset.skbRemove, 0); return; }
    const msgEl = document.getElementById('skb-card-msg');
    const msg = msgEl ? msgEl.value.trim() : '';
    if (!msg) { const err = document.getElementById('skb-card-err'); if (err) err.hidden = false; msgEl && msgEl.focus(); return; }
    if (t.dataset.skbCardAdd) add(t.dataset.skbCardAdd, { 'Card message': msg });
    else change(t.dataset.skbCardSave, 1, { 'Card message': msg });
  });
  document.addEventListener('change', (e) => {
    if (e.target.id !== 'skb-gift-on') return;
    giftOpen = e.target.checked;
    try { sessionStorage.setItem('skb-gift', giftOpen ? '1' : '0'); } catch (err) {}
    paint();
  });
  document.addEventListener('input', (e) => {
    if (e.target.id !== 'skb-card-msg') return;
    cardDraft = e.target.value;
    const c = document.querySelector('.skb-count');
    if (c) c.textContent = e.target.value.length + '/200';
    const err = document.getElementById('skb-card-err');
    if (err) err.hidden = true;
  });

  /* Read the cart from the theme's own cart requests, so the blocks redraw in the same frame as the drawer. */
  const nativeFetch = window.fetch.bind(window);
  let fresh = false;
  window.fetch = async (...args) => {
    const res = await nativeFetch(...args);
    try {
      const url = String(args[0] && args[0].url ? args[0].url : args[0]);
      if (/\/cart\/(change|update|clear)/.test(url) && res.ok) {
        const j = await res.clone().json();
        if (j && Array.isArray(j.items) && 'total_price' in j) { cart = j; fresh = true; }
      }
    } catch (e) {}
    return res;
  };

  /* The theme's cart code throws on a quantity of 0 (it treats 0 as below the minimum of 1),
     so the line never leaves the cart. Remove it here instead. */
  document.addEventListener('change', (e) => {
    const inp = e.target;
    if (!inp.matches || !inp.matches('cart-drawer .quantity__input')) return;
    if (parseInt(inp.value, 10) !== 0) return;
    e.stopImmediatePropagation();
    const key = inp.dataset.quantityLineKey;
    if (key) change(key, 0);
  }, true);

  /* Dawn redraws the drawer after every cart change; re-place the blocks each time. */
  let timer;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 80); };
  function start() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(() => {
      if (drawer.querySelector('#skb-top') && drawer.querySelector('#skb-extras')) return;
      if (cart) paint();
      if (fresh) fresh = false; else schedule();
    }).observe(drawer, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
